import {getRolesTypes, returnElementFromArray} from "@helpers";

export const getRoleName = (id) => {
    var roles = getRolesTypes();
    var element = returnElementFromArray(id, roles, 'id');
    if (element) {
        return element.name;
    } else return '';
}